import CflTurnoverOnDownStats from "./general/downs/cfl-turnover-on-down-stats";
import CflFieldGoalStats from "./general/kicks/fieldgoal/cfl-field-goal-stats";
import CflTeamLossStats from "./misc/cfl-team-loss-stats";
import CflMissedFieldGoalReturnStats from "./specialteams/punt/return/cfl-missed-field-goal-return-stats";

const CflRules = Object.freeze({
    General: Object.freeze({
        Kicks: Object.freeze({
            RecordStatsFieldGoal: new CflFieldGoalStats()
        }),
        TurnoverOnDownStats: new CflTurnoverOnDownStats()
    }),
    Miscellaneous: Object.freeze({
        RecordStatsTeamLoss: new CflTeamLossStats()
    }),
    SpecialTeams: Object.freeze({
        Punt: Object.freeze({
            Return: Object.freeze({
                RecordStatsFg: new CflMissedFieldGoalReturnStats()
            })
        })
    })
});

export default CflRules;
